import { generateId } from 'utils/helpers';
import { actionTypes } from './actionTypes';
import type {
  AddToastPayload,
  RemoveToastByKeyPayload,
  ReducerAddToastActionType,
  ReducerRemoveAllActionType,
  ReducerRemoveByKeyActionType,
} from './types';

export const addToastRequest = (payload: AddToastPayload): ReducerAddToastActionType => ({
  type: actionTypes.ADD,
  payload: {
    ...payload,
    key: payload.key || generateId(),
  },
});

export const removeAllToastsRequest = (): ReducerRemoveAllActionType => ({
  type: actionTypes.REMOVE_ALL,
  payload: undefined,
});

export const removeToastByKeyRequest = (
  payload: RemoveToastByKeyPayload,
): ReducerRemoveByKeyActionType => ({
  type: actionTypes.REMOVE_KEY,
  payload,
});
